import React, { useState } from "react";
import { createPost } from "./api/forumApi";
import { useNavigate } from "react-router-dom";
import "./createpost.css";

export default function CreatePost() {

  const user = JSON.parse(localStorage.getItem("user") || "null");

  const [form, setForm] = useState({
    title: "",
    content: "",
    author: user?.username || "Unknown User",
    image: "",
    tag: "announcement"
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();


  const update = (key, value) => {

    setForm({
      ...form,
      [key]: value
    });

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);
    setError("");

    try {

      await createPost(form);

      navigate("/");

    }

    catch {

      setError("Something went wrong creating your post.");

    }

    finally {

      setLoading(false);

    }

  };



  return (

    <div className="create-wrapper">


      <div className="create-panel">



        <div className="create-title">

          <div className="logo-circle">
            ⚡
          </div>

          <div>

            <h1>
              Create Announcement
            </h1>

            <p>
              Post an update to the Vortex community
            </p>

          </div>


        </div>





        {error &&

          <div className="create-error">
            {error}
          </div>

        }





        <form
          className="create-form"
          onSubmit={handleSubmit}
        >



          <div className="field">

            <label>
              Post Title
            </label>


            <input

              placeholder="Example: Prison Addon Update v1.6.2"

              value={form.title}

              onChange={
                e => update("title", e.target.value)
              }

            />

          </div>







          <div className="field">


            <label>
              Author
            </label>


            <div className="profile-box">

              <div className="avatar">

                {form.author.charAt(0)}

              </div>


              {form.author}


            </div>


          </div>







          <div className="field">


            <label>
              Image URL
            </label>


            <input

              placeholder="https://image.png"

              value={form.image}

              onChange={
                e => update("image", e.target.value)
              }

            />


          </div>





          {form.image &&

            <div className="preview-image">

              <img src={form.image} alt="Post preview" />

            </div>

          }







          <div className="field">


            <label>
              Category
            </label>


            <div className="category-list">


              {
                [
                  ["announcement", "📢 Announcement"],
                  ["update", "🔄 Update"],
                  ["patch", "🛠 Patch"],
                  ["news", "📰 News"]

                ].map(x =>

                  <button

                    type="button"

                    className={
                      form.tag === x[0]
                        ? "category active"
                        : "category"
                    }

                    onClick={() => update("tag", x[0])}

                  >

                    {x[1]}

                  </button>

                )

              }



            </div>


          </div>







          <div className="field">


            <label>
              Content
            </label>


            <textarea

              placeholder="Write your update..."

              value={form.content}

              onChange={
                e => update("content", e.target.value)
              }

            />



            <div className="progress">


              <div

                style={{
                  width: `${(form.content.length / 2000) * 100}%`
                }}

              ></div>


            </div>


            <span>

              {form.content.length}/2000

            </span>


          </div>








          <div className="post-preview">


            <h3>
              Preview
            </h3>


            <h2>

              {form.title || "Your title"}

            </h2>


            <p>

              {form.content || "Your post content will appear here"}

            </p>


          </div>







          <button
            disabled={loading}
            className="publish"
          >


            {loading
              ? "Publishing..."
              : "🚀 Publish Post"
            }


          </button>



        </form>



      </div>


    </div>

  );

}